<script lang="ts">
  import type { UserClassSummary } from '$lib/api/types';
  import { utcNowIso } from '$lib/util';
  import TableMessage from '../TableMessage.svelte';

  interface Props {
    classes: UserClassSummary[];
  }

  let { classes }: Props = $props();

  let today = utcNowIso().split('T')[0];
  let currentUpcomingClass = classes.filter(c => c.endDate >= today);
  let pastClasses = classes.filter(c => c.endDate < today);
</script>

{#snippet classItem(classSummary: UserClassSummary)}
  <a href="/admin/classes/{classSummary.classId}" class="list-group-item list-group-item-action">
    <h4 class="list-group-title">{classSummary.className}</h4>
    <div class="list-group-subtitle">{classSummary.clinicalGroupName}</div>
  </a>
{/snippet}

<h3 class="subtle-header">Current and upcoming classes</h3>
<div class="list-group mb-3">
  {#each currentUpcomingClass as _class (_class.classId)}
    {@render classItem(_class)}
  {/each}
  {#if currentUpcomingClass.length === 0}
    <TableMessage message="No current or upcoming classes" />
  {/if}
</div>
<h3 class="subtle-header">Past classes</h3>
<div class="list-group">
  {#each classes.filter(x => x.endDate < today) as _class (_class.classId)}
    {@render classItem(_class)}
  {/each}
  {#if pastClasses.length === 0}
    <TableMessage message="No past classes" />
  {/if}
</div>
